import { render, staticRenderFns } from "./WorkTypeFormModal.vue?vue&type=template&id=5a2326e1&scoped=true&"
import script from "./WorkTypeFormModal.vue?vue&type=script&lang=js&"
export * from "./WorkTypeFormModal.vue?vue&type=script&lang=js&"
import style0 from "./WorkTypeFormModal.vue?vue&type=style&index=0&id=5a2326e1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2326e1",
  null
  
)

export default component.exports